<template>
  <div>
    <div
      class="container"
      v-if="spinner"
      style="padding-bottom: 280px !important; padding-top: 280px !important"
    >
      <div class="col-lg-6 col-md-6 ml-auto mr-auto">
        <div id="loading-bg">
          <div class="loading-logo">
            <!-- <img
              src="favicon.ico"
              alt="Logo"
              style="
                max-width: 120px;
                margin-top: 200px;
                right: 20px;
                position: relative;
              "
            /> -->
          </div>
          <div class="loading">
            <div class="effect-1 effects"></div>
            <div class="effect-2 effects"></div>
            <div class="effect-3 effects"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="container"
      v-if="!tokenSucess && !spinner && !registerResponse"
      style="padding-bottom: 90px !important; padding-top: 90px !important"
    >
      <div class="col-lg-6 col-md-6 ml-auto mr-auto">
        <form @submit.prevent="login">
          <card
            class="card-login card-white text-left"
            style="border-radius: 10"
          >
            <template slot="header">
              <img src="icons8-trash-200.png" class="card-img-email" alt="" />
            </template>

            <div>
              <h1 class="card-title text-center">
                Link de Restablecer Contraseña Caducado
              </h1>
              <!-- <p>El link de registro ha expirado.</p> -->
            </div>

            <div slot="footer"></div>
          </card>
        </form>
      </div>
    </div>
    <div class="container" v-if="tokenSucess && !spinner && !registerResponse">
      <div class="row">
        <div class="col-md-5 ml-auto backgroud-image">
          <!-- <div class="info-area info-horizontal mt-5" >
          
          <div class="icon icon-warning">
            <i class="tim-icons icon-wifi"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Marketing</h3>
            <p class="description">
              We've created the marketing campaign of the website. It was a very
              interesting collaboration.
            </p>
          </div>
        </div>
        <div class="info-area info-horizontal">
          <div class="icon icon-primary">
            <i class="tim-icons icon-triangle-right-17"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Fully Coded in HTML5</h3>
            <p class="description">
              We've developed the website with HTML5 and CSS3. The client has
              access to the code using GitHub.
            </p>
          </div>
        </div>
        <div class="info-area info-horizontal">
          <div class="icon icon-info">
            <i class="tim-icons icon-trophy"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Built Audience</h3>
            <p class="description">
              There is also a Fully Customizable CMS Admin Dashboard for this
              product.
            </p>
          </div> 
        </div>-->
        </div>

        <div class="col-md-7 mr-auto">
          <form>
            <card
              class="card-register card-white text-left"
              style="padding: 50px 0px"
            >
              <h3 style="text-align: center">Cambiar contraseña</h3>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-label">
                    <slot name="label">
                      <label> Email </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="email"
                          type="text"
                          placeholder="Email"
                          style="text-align: left !important"
                          disabled
                        />
                      </slot>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': $v.password.$error,
                    }"
                  >
                    <slot name="label">
                      <label> Contraseña </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="password"
                          type="password"
                          placeholder="Contraseña"
                          style="text-align: left !important"
                        />
                      </slot>
                    </div>
                    <slot
                      name="error"
                      v-if="!$v.password.required && $v.password.$error"
                    >
                      <label class="error">Este campo es requerido</label>
                    </slot>
                    <slot
                      name="error"
                      v-else-if="
                        !$v.password.goodPassword && $v.password.$error
                      "
                    >
                      <label class="error"
                        >Debe tener al menos 8 caracteres y contener un carácter
                        en minúscula, un carácter en mayúscula y un
                        número.</label
                      >
                    </slot>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': !$v.confirmPassword.sameAsPassword,
                    }"
                  >
                    <slot name="label">
                      <label> Confirmar Contraseña </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="confirmPassword"
                          type="password"
                          placeholder="Confirmar Contraseña"
                          style="text-align: left !important"
                        />
                      </slot>
                    </div>
                    <slot
                      name="error"
                      v-if="!$v.confirmPassword.sameAsPassword"
                    >
                      <label class="error"
                        >Las contraseñas deben ser idénticas.</label
                      >
                    </slot>
                  </div>
                </div>
              </div>

              <!-- <base-input
              v-validate="'required'"
              v-model="model.fullName"
              name="Full Name"
              placeholder="Full Name"
              addon-left-icon="tim-icons icon-single-02"
            >
            </base-input>

            <base-input
              v-validate="'required|email'"
              v-model="model.email"
              name="email"
              placeholder="Email"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>

            <base-input
              v-validate="'required|min:5'"
              v-model="model.password"
              name="password"
              type="password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input> -->

              <!-- <base-checkbox class="text-left">
              Acepto los
              <a href="#something">términos y condiciones.</a>.
            </base-checkbox> -->

              <base-button
                slot="footer"
                type="primary"
                block
                size="lg"
                @click="resetPassword"
                :loading="registerLoading"
              >
                Cambiar Contraseña
              </base-button>
            </card>
          </form>
        </div>
      </div>
    </div>

    <div class="container" v-if="tokenSucess && !spinner && registerResponse">
      <div class="row">
        <div class="col-md-5 ml-auto backgroud-image"></div>

        <div class="col-md-7 mr-auto">
          <form>
            <card
              class="card-register card-white text-left"
              style="padding: 217px 0px"
            >
              <h2 style="text-align: center">Contraseña cambiada</h2>
              <h5 style="text-align: center">
                Has restablecido tu contraseña exitosamente ya puedes iniciar
                sesión con tu nueva contraseña
              </h5>
              <div class="row">
                <!-- <div class="col-md-6">
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': $v.firstName.$error,
                    }"
                  >
                    <slot name="label">
                      <label> Nombre </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="firstName"
                          type="text"
                          placeholder="Nombre"
                          disabled
                          style="text-align: left !important"
                        />
                      </slot>
                    </div>
                    <slot name="error" v-if="$v.firstName.$error">
                      <label class="error">Este campo es requerido</label>
                    </slot>
                  </div>
                </div> -->
              </div>
            </card>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card } from "@/components/index";
import { DatePicker, Select } from "element-ui";
import { required, sameAs } from "vuelidate/lib/validators";
import moment from "moment";
import axios from "axios";
import firebase from "firebase/compat/app";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    Card,
  },
  data() {
    return {
      userId: "",
      userMemberId: "",
      firstName: "",
      lastName: "",
      phone: "",
      birthdayDate: "",
      gender: "",
      email: "",
      password: "",
      confirmPassword: "",

      tokenSucess: false,
      spinner: true,

      registerLoading: false,
      registerResponse: false,

      disabledFirstName: false,
      disabledLastName: false,
      disabledPhone: false,
      disabledBirthdayDate: false,
      disabledGender: false,
    };
  },
  validations: {
    password: {
      required,
      goodPassword: (password) => {
        //a custom validator!
        return (
          password.length >= 8 &&
          /[a-z]/.test(password) &&
          /[A-Z]/.test(password) &&
          /[0-9]/.test(password)
        );
      },
    },
    confirmPassword: {
      sameAsPassword: sameAs("password"),
    },
  },
  methods: {
    resetPassword() {
      let instance = this;
      this.$v.$touch();
      //console.log(this.$v);
      if (!this.$v.$error) {
        this.registerLoading = true;
        firebase
          .auth()
          .confirmPasswordReset(this.$route.query.oobCode, this.password)
          .then(function() {
            instance.registerResponse = true;
            instance.registerLoading = false;
          })
          .catch(function() {
            // Invalid code
            this.$router.go(this.$router.currentRoute);
          });
      }
    },
    register() {
      let instance = this;
      this.$v.$touch();
      //console.log(this.$v);
      if (!this.$v.$error) {
        this.registerLoading = true;
        let token = this.$route.query.token;
        let data = {
          userId: this.userId,
          userName: this.firstName,
          userLastName: this.lastName,
          userMemberId: this.userMemberId,
          userEmail: this.email,
          userDOB: moment(this.birthdayDate).format("YYYY-MM-DD"),
          userMobile: this.phone,
          userSexId: this.gender,
          userPassword: this.password,
        };
        axios
          .post(`${process.env.VUE_APP_API_URL}/api/v1/users/`, data, {
            params: {
              token: token,
            },
          })
          .then((response) => {
            console.log(response);
            instance.registerResponse = true;
            instance.registerLoading = false;
          })
          .catch((error) => {
            console.log(error);
            this.$router.go(this.$router.currentRoute);
          });
        // this.registerLoading = true;
        // setTimeout(function () {
        //   instance.registerResponse = true;
        //   instance.registerLoading = true;
        // }, 2000);
      }
    },
  },
  async mounted() {
    let instance = this;
    if (this.$route.query.oobCode) {
      firebase
        .auth()
        .verifyPasswordResetCode(this.$route.query.oobCode)
        .then(function(email) {
          instance.email = email;
          // instance.showInvalidResetPassword = false;
          // instance.showResetPassword = true;
          // instance.showValidResetPassword = false;

          // instance.email = email;
          instance.tokenSucess = true;
          instance.spinner = false;
        })
        .catch(function() {
          // instance.showInvalidResetPassword = true;
          // instance.showResetPassword = false;
          // instance.showValidResetPassword = false;
          instance.tokenSucess = false;
          instance.spinner = false;
        });
    } else {
      instance.tokenSucess = false;
      instance.spinner = false;
    }

    // let token = this.$route.query.token;
    // // https://rx0rkga0df.execute-api.us-east-1.amazonaws.com/api/v1/user/preregister/${token}`
    // axios
    //   .get(
    //     `${process.env.VUE_APP_API_URL}/api/v1/users/preregister`,
    //     {
    //       params: {
    //         token: token,
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     console.log(response);
    //     this.userId = response.data.userId;
    //     this.userMemberId = response.data.userMemberId;
    //     this.firstName = response.data.userName;
    //     this.lastName = response.data.userLastName;
    //     this.phone = response.data.userMobile;
    //     this.birthdayDate = response.data.userDOB
    //       ? moment(response.data.userDOB).toDate()
    //       : "";
    //     this.email = response.data.userEmail;
    //     this.gender = response.data.userSexId;

    //     // this.disabledFirstName = this.firstName ? false : false;
    //     // this.disabledLastName = this.lastName ? false : false;
    //     // this.disabledPhone = this.phone ? false : false;
    //     // this.disabledBirthdayDate = this.birthdayDate ? false : false;
    //     // this.disabledGender = this.gender ? false : false;

    //     this.tokenSucess = true;
    //     this.spinner = false;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     this.tokenSucess = false;
    //     this.spinner = false;
    //   });
  },
};
</script>
<style lang="scss" scoped>
.backgroud-image {
  background-image: url("../../assets/img/Imagen_FormularioRegistro.jpg");
  background-size: cover;
}

@media screen and (max-width: 640px) {
  .backgroud-image {
    background-image: url("../../assets/img/User_Back.jpg");
    background-size: cover;
    height: 100px;
    margin-left: 15px !important;
    margin-right: 15px !important;
  }
}
</style>
